import { useUserConfig } from '@littlebird/sdk';

export const useCodingFollowUp = () => {
  const userConfig = useUserConfig();
  return {
    onlyLittlebirdRuns: userConfig.proactiveAgents.get(
      'coding_only_started_by_littlebird'
    ),
    setOnlyLittlebirdRuns: (only: boolean) =>
      userConfig.proactiveAgents.set('coding_only_started_by_littlebird', only),
  };
};
